
import {Component, Prop, Vue} from 'vue-property-decorator';
import {FormBuilder} from 'v-form-builder';
import {dispatchGetFormCategories, dispatchRegisterForm} from '@/store/admin/actions';
import {IForm} from '@/interfaces/form';
import {commitAddNotification} from '@/store/main/mutations';
import RendererDialog from '@/components/dialogs/RendererDialog.vue';
import ImportFormSettings from '@/components/dialogs/ImportFormSettings.vue';
import {IRoleSettings} from '@/interfaces/role';
import {arrDifference, rules} from '@/utils';
import AlertDialogWrapper from '@/components/dialogs/AlertDialogWrapper.vue';
import AlertDialogFrame from '@/components/dialogs/AlertDialogFrame.vue';
import {readFormCategories} from "@/store/admin/getters";

@Component({
  components: {AlertDialogFrame, AlertDialogWrapper, ImportFormSettings, RendererDialog, FormBuilder},
})
export default class CreateForm extends Vue {
  @Prop(Number) public formId: undefined;
  public isRenderer: boolean = false;
  public formData: any = null;
  public formInputData: any = null;
  public baseFormData: object | undefined = {};
  public formTitle: string = '';
  public formCategoryId: any = null;
  public isEnabled: boolean = true;

  private valid: boolean = false;
  private rules: any = rules;
  private FCTitle: string = `${this.$t('crud.create')} ${this.$t('form')}`;

  private alertDialog: any = null;
  private alertHeader: string = '';
  private alertMessage: string = '';

  private get formCategories() {
    return readFormCategories(this.$store)
  }

  public revertForm() {
    this.formTitle = '';
    this.formData = {};
  }

  public loadOldForm() {
    if (this.formId === 0) {
      return;
    }
  }

  public importFunction(val) {
    if (val && val instanceof Object && val?.form_setting?.form_data) {
      this.formData = {...val?.form_setting?.form_data} as unknown as IRoleSettings;
    }
  }

  public viewRenderer() {
    if (this.formData === null) {
      return;
    }
    if (!this.isRenderer) {
      this.isRenderer = true;
      return;
    }

    this.isRenderer = false;
  }

  public cancel() {
    this.$router.back();
  }

  public async saveForm() {
    // TODO verificar possibilidade de analisar se o formulário possui pelo menos um campo
    const form: any = this.$refs.form_create_form;
    if (await form.validate()) {
      if (!Object.keys(this.formData?.controls).length) {
        commitAddNotification(this.$store, {
          content: `Não há campos no formulário! Insira pelo menos um para continuar...`,
          color: 'warning',
        });
        return;
      }

      const formControls = this?.formData?.controls;
      if (formControls) {
        const checkFields = await Object.values(formControls).filter((e: any) => e?.name === '')
          .map((e: any) => e?.label);
        this.alertHeader = 'Atenção!';
        if (checkFields.length > 0) {
          this.alertMessage = `O formulário possui alguns controles sem o campo 'name' definido:<br/>
                             Controles: <pre class="text-break">${JSON.stringify(checkFields)}</pre><br/>
                             <b>É altamente recomendável que todos os controles possuam um nome (rótulo)
                             para padronização dos dados.</b><br/><br/>
                             Deseja continuar?`;
          const resp = await this.alertDialog.open({width: 600}).then((result) => {
            return result;
          });
          if (!resp) {
            return;
          }
        }
        const controls = Object.values(formControls);
        let checkDuplicatedNames = await controls.map((e: any) => e?.name);
        checkDuplicatedNames = checkDuplicatedNames.filter((e: any, i) => checkDuplicatedNames.indexOf(e) !== i);

        if (checkDuplicatedNames.length > 0) {
          this.alertMessage = `O formulário possui alguns controles com o campo 'name' duplicados:<br/>
                             Controles: <pre class="text-break">${JSON.stringify(checkDuplicatedNames)}</pre><br/>
                             <b>É altamente recomendável que todos os controles possuam um nome (rótulo) único.</b>
                             <br/><br/>
                             <b>Se você continuar, é possível haver inconsistências nos dados registrados.</b><br/>
                             Deseja realmente continuar?`;
          const resp = await this.alertDialog.open({width: 600}).then((result) => {
            return result;
          });
          if (!resp) {
            return;
          }
        }
        const dataToSave: IForm = {
          title: this.formTitle,
          form_setting: this.formData,
          is_enabled: this.isEnabled,
          form_category_id: this.formCategoryId,
        };
        if (await dispatchRegisterForm(this.$store, dataToSave)) {
          await this.$router.push('/main/admin/forms');
        }

      }
    }
  }

  public async mounted() {
    await dispatchGetFormCategories(this.$store)
    this.alertDialog = this.$refs.alert_dialog;
    // @ts-ignore
    // console.log(this.$formEvent._events);
  }

  public beforeRouteLeave(to, from, next) {
    // @ts-ignore
    // console.log(this.$formEvent._events);
    this.formData = {
      controls: {},
      formConfig: {},
      rows: {},
      sections: {},
    };
    this.$destroy();
    next();
  }

}
